import { render, staticRenderFns } from "./UserPositionHighlight.vue?vue&type=template&id=52c5950d"
import script from "./UserPositionHighlight.vue?vue&type=script&lang=js"
export * from "./UserPositionHighlight.vue?vue&type=script&lang=js"
import style0 from "./UserPositionHighlight.vue?vue&type=style&index=0&id=52c5950d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports